import { render, staticRenderFns } from "./ticket_setting.vue?vue&type=template&id=f375b644&"
import script from "./ticket_setting.vue?vue&type=script&lang=js&"
export * from "./ticket_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports